export default __webpack_public_path__ + "3fafcec74db3cd37099b035ef4ca4816.png";